import React, { useState } from 'react';
import { Button, Modal, ModalContent, ModalCloseButton } from '../common';
import { Heading, Text } from '../common/Typography';
import { NumberInput } from '../common/Form';

const RejectJoinRequestModal = ({ isOpen, onClose, onConfirm, playerName, loading = false }) => {
  const [rejectionMessage, setRejectionMessage] = useState('');
  const [cooldownDays, setCooldownDays] = useState(7);
  const [blockFuture, setBlockFuture] = useState(false);

  const handleConfirm = () => {
    onConfirm({
      rejectionMessage: rejectionMessage.trim() || null,
      cooldownDays: blockFuture ? 0 : cooldownDays,
      blockFuture,
    });
  };

  const handleClose = () => {
    setRejectionMessage('');
    setCooldownDays(7);
    setBlockFuture(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} closeOnBackdropClick={!loading}>
      <ModalContent size="small" className="overflow-y-auto">
        <div className="flex items-start justify-between gap-2 mb-4 pr-8">
          <Heading level={3}>Reject Join Request</Heading>
          <ModalCloseButton onClose={handleClose} className="static shrink-0" ariaLabel="Close" />
        </div>

        <Text className="mb-4 text-text-secondary">
          Rejecting join request from <strong>{playerName}</strong>
        </Text>

        <div className="mb-4">
          <label className="block text-sm font-medium text-text-primary mb-2">Rejection Message (Optional)</label>
          <textarea
            value={rejectionMessage}
            onChange={(e) => setRejectionMessage(e.target.value)}
            placeholder="Enter a message explaining the rejection..."
            className="w-full px-3 py-2 border border-border-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-surface text-text-primary"
            rows={3}
            disabled={loading}
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-text-primary mb-2">Cooldown Period (Days)</label>
          <NumberInput
            value={cooldownDays}
            onChange={(e) => {
              const value = e.target.value === '' ? 0 : Number(e.target.value);
              setCooldownDays(value >= 0 ? value : 0);
            }}
            min={0}
            max={365}
            disabled={loading || blockFuture}
            className="w-full"
          />
          <Text className="text-xs text-text-muted mt-1">
            {blockFuture
              ? 'Blocked - user cannot request again'
              : cooldownDays === 0
                ? 'No cooldown - user can request again immediately'
                : `User can submit a new request after ${cooldownDays} day${cooldownDays !== 1 ? 's' : ''}`}
          </Text>
        </div>

        <div className="mb-6">
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={blockFuture}
              onChange={(e) => {
                setBlockFuture(e.target.checked);
                if (e.target.checked) {
                  setCooldownDays(0);
                } else {
                  setCooldownDays(7);
                }
              }}
              disabled={loading}
              className="w-4 h-4 text-danger border-border-medium rounded focus:ring-danger"
            />
            <span className="ml-2 text-sm text-text-secondary">Block future requests from this user</span>
          </label>
        </div>

        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:gap-3">
          <Button onClick={handleClose} variant="outline" className="flex-1" disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="primary"
            className="flex-1 bg-danger hover:bg-danger-dark text-white"
            disabled={loading}
          >
            {loading ? 'Rejecting...' : 'Reject Request'}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default RejectJoinRequestModal;
